import { ChangeDetectionStrategy, Component, ViewContainerRef } from '@angular/core'
import { CmsFacetService } from '../../../services/cms-search/cms-facet.service'
import { combineLatest } from 'rxjs'
import { Facet, FacetCount } from 'smartsearch.js'
import { ICON_TYPE } from '@spartacus/storefront'
import { CmsFacet, CmsFacetCount, ContentQuery } from '../../types'
import { MbSpinnerService } from '../../../../shared/services/mb-spinner.service'
import { map } from 'rxjs/operators'
import { CmsLinkType } from '../../../enums/cms-link-type'

@Component({
  selector: 'mb-cms-active-facets',
  templateUrl: './cms-active-facets.component.html',
  styleUrls: ['./cms-active-facets.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsActiveFacetsComponent {

  activeFacets$ = combineLatest([this.cmsFacetService.activeFacets$, this.cmsFacetService.readonlyFacets$]).pipe(
    map(([activeFacets, readonlyFacets]) => this.createActiveFacets(activeFacets, readonlyFacets)))

  icon = ICON_TYPE.CLOSE

  constructor (private cmsFacetService: CmsFacetService,
               private mbSpinnerService: MbSpinnerService,
               private vcr: ViewContainerRef) {
  }

  private createActiveFacets (activeFacets: Facet[], readonlyFacets: CmsFacet[]): Facet[] {
    readonlyFacets.forEach(roFacet => {
      if (!activeFacets.find(facet => facet.config.baseName === roFacet.category?.replaceAll(' ', '_'))) {
        activeFacets.push(this.cmsFacetService.getFacetFromReadonlyFacet(roFacet))
      } else {
        activeFacets = activeFacets.map(facet => facet.config.baseName === roFacet.category
          ? {
            ...facet,
            counts: [this.cmsFacetService.getFacetCountFromReadonlyFacet(roFacet)]
          }
          : facet) as Facet[]
      }
    })
    return activeFacets
  }

  getQueryParam (facetCount: FacetCount): ContentQuery {
    return this.cmsFacetService.getQueryParamWithoutFacetCount(facetCount as CmsFacetCount)
  }

  isReadonlyFacet (facetCount: CmsFacetCount | FacetCount): boolean {
    return this.cmsFacetService.isReadonlyFacet(facetCount)
  }

  getFacetCategoryName (facet: Facet): string {
    return facet?.config?.baseName?.replaceAll('_', ' ') ?? ''
  }

  onRemoveFacetClick () {
    this.mbSpinnerService.launchMbSpinner(this.vcr)
  }

  protected readonly cmsLinkType = CmsLinkType
}
